import { Regulation } from './types'

const regulation: Regulation = {
    title: 'Omgevingsverordening',
    structure: [{ type: 'chapter' }],
}

export default regulation
